import Vue from 'vue';
import {
  ADD_ALL_CLIENT_WINES_REQUEST,
  ADD_ALL_CLIENT_WINES_SUCCESS,
  ADD_ALL_CLIENT_WINES_ERROR,
  GET_WINES_REQUEST,
  GET_WINES_SUCCESS,
  GET_WINES_ERROR,
  GET_ALL_CLIENT_WINES_REQUEST,
  GET_ALL_CLIENT_WINES_SUCCESS,
  GET_ALL_CLIENT_WINES_ERROR
} from './actionTypes';
import wineApi from '../../_api/wine';

const state = {
  wines: {},
  status: '',
  errors: [],
  hasLoadedOnce: false
};

const getters = {
  wines: (state) => state.wines
};

const actions = {
  [ADD_ALL_CLIENT_WINES_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(ADD_ALL_CLIENT_WINES_REQUEST);
      wineApi
        .addAllClientWines(payload)
        .then((response) => {
          commit(ADD_ALL_CLIENT_WINES_SUCCESS, response);
          resolve(response);
        })
        .catch((error) => {
          commit(ADD_ALL_CLIENT_WINES_ERROR, error);
          reject(error);
        });
    });
  },

  [GET_WINES_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(GET_WINES_REQUEST);
      wineApi
        .getWines(payload)
        .then((response) => {
          commit(GET_WINES_SUCCESS, response);
          resolve(response);
        })
        .catch((error) => {
          commit(GET_WINES_ERROR, error);
          reject(error);
        });
    });
  },
  [GET_ALL_CLIENT_WINES_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(GET_ALL_CLIENT_WINES_REQUEST);
      wineApi
        .getAllClientWines(payload)
        .then((response) => {
          commit(GET_ALL_CLIENT_WINES_SUCCESS, response);
          resolve(response);
        })
        .catch((error) => {
          commit(GET_ALL_CLIENT_WINES_ERROR, error);
          reject(error);
        });
    });
  }
};

const mutations = {
  [ADD_ALL_CLIENT_WINES_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [ADD_ALL_CLIENT_WINES_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
    Vue.set(state, 'wines', response.data.results);
  },
  [ADD_ALL_CLIENT_WINES_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },

  [GET_WINES_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [GET_WINES_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
    Vue.set(state, 'wines', response.data.results);
  },
  [GET_WINES_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },

  [GET_ALL_CLIENT_WINES_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [GET_ALL_CLIENT_WINES_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.hasLoadedOnce = true;
  },
  [GET_ALL_CLIENT_WINES_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
